import { axiosInstance } from '../lib/api_client'

type SetLink = Readonly<{
  name: string
  nameEn?: string
  path: string
  snippet?: string
}>

type Crumb = Readonly<{
  name: string
  path?: string | null
}>

type SetLandingDocument = Readonly<{
  title: string
  description: string
  h1: string
  intro: string
  canonicalPath: string
  listingsPath?: string | null
  listingsLabel?: string | null
  eraName?: string | null
  eraPath?: string | null
  cardCount?: number | null
  forSaleCount?: number | null
  cards: SetLink[]
  sets: SetLink[]
  eras: SetLink[]
  siblings: SetLink[]
  breadcrumbs: Crumb[]
}>

type JpSetLandingsRepository = Readonly<{
  index: () => Promise<SetLandingDocument>
  get: (slug: string) => Promise<SetLandingDocument>
  era: (slug: string) => Promise<SetLandingDocument>
}>

const jpSetLandingsRepository: JpSetLandingsRepository = {
  async index () {
    const { data } = await axiosInstance.get('/seo/jp_set_landings')
    return data.setLandingIndex as SetLandingDocument
  },
  async get (slug: string) {
    const { data } = await axiosInstance.get(`/seo/jp_set_landings/${slug}`)
    return data.setLanding as SetLandingDocument
  },
  async era (slug: string) {
    const { data } = await axiosInstance.get(`/seo/jp_set_eras/${slug}`)
    return data.setEra as SetLandingDocument
  },
}

export type { SetLandingDocument, SetLink }
export { jpSetLandingsRepository }
